<template>
  <div class="bg-white">
    <div class="relative z-index1 h-full w-full">
      <div class="">
        <Welcome />
        <HeartAbout />
        <Cards />
        <Partner />
        <HeartNews />
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Welcome from "./components/Welcome.vue";
import HeartAbout from "./components/HeartAbout.vue";
import Cards from "./components/Cards.vue";
import Partner from "./components/Partner.vue";
import HeartNews from "./components/HeartNews.vue";
import Footer from "../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";

export default {
  components: {
    Welcome,
    HeartAbout,
    Cards,
    Partner,
    HeartNews,
    Footer,
    DownloadApp,
  },
};
</script>

<style></style>
